import * as React from 'react';
import { Form, Input, Button } from 'antd';
import { Container, Table, TableBody, TableRow, TableCell, TableHead, Typography } from '@mui/material';
import { PlusCircleOutlined } from '@ant-design/icons';
// import AddIcon from '@mui/icons-material/Add';
import 'antd/dist/antd.css';

import AddSKUModal from '../components/addSKUModal';
import SKUItemRow from '../components/SKUItemRow';
import { SingleProductContext } from '../context/SingleProductContext';

export default function ProductVariationCard({ form }) {
  const {
    skus,
    editSku,
    editSkuHandler,
    submitSkuHandler,
    addSKUModal,
    cancelModalHandler,
    stockChangeHandler,
    skuDeleteHandler,
    productDetail,
  } = React.useContext(SingleProductContext);

  React.useEffect(() => {
    if (
      productDetail && // 👈 null and undefined check
      Object.keys(productDetail).length === 0 &&
      Object.getPrototypeOf(productDetail) === Object.prototype
    ) {
      form.resetFields();
    } else {
      form.setFieldsValue(productDetail);
    }
  }, [productDetail]);

  return (
    <Container sx={{ py: 3 }}>
      <h2>สินค้าย่อย</h2>

      <Form.Item name='variation_title' label='หัวข้อสินค้าย่อย'>
        <Input placeholder='เช่น ขนาด, สี, ตัวเลือก' />
      </Form.Item>

      <Form.Item
        wrapperCol={{
          span: 18,
          offset: 3,
        }}>
        <Table aria-label='custom pagination table'>
          <TableHead>
            <TableRow>
              <TableCell colSpan={7}>
                <div style={{ float: 'left', width: '50%' }}>
                  <Typography variant='h6'>รายการตัวเลือก</Typography>
                </div>
                <div style={{ float: 'right', textAlign: 'right', width: '50%' }}>
                  <Button type='primary' icon={<PlusCircleOutlined />} onClick={editSkuHandler}>
                    เพิ่มรายการ
                  </Button>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ลำดับ</TableCell>
              <TableCell>รูป SKU</TableCell>
              <TableCell>ชื่อ SKU</TableCell>
              <TableCell>ราคา</TableCell>
              <TableCell>SKU</TableCell>
              <TableCell>มีสต๊อค</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {skus.map((row) =>
              row.status === 'delete' ? null : (
                <SKUItemRow
                  key={row.id}
                  skuItem={row}
                  onEdit={editSkuHandler}
                  onStockChange={stockChangeHandler}
                  onDelete={skuDeleteHandler}
                />
              )
            )}
          </TableBody>
        </Table>
      </Form.Item>
      <AddSKUModal
        skuItem={editSku}
        visible={addSKUModal}
        onCancel={cancelModalHandler}
        onFinish={submitSkuHandler}
        width={600}
      />
    </Container>
  );
}
